export const AVAILABLE_SLOTS_TITLE = 'Select new appointment time:';
export const OTHER_SLOTS_AVAILABLE_TITLE = 'Other slots available:';
export const VIEW_MORE_DATES = 'View more dates';
export const NO_AVAILABLE_SLOTS_MESSAGE = 'No appointments available on this day.';
export const LOADER_TITLE = 'Loading appointment times';
export const LOADER_SUBTITLE = 'Please bear with us.';
export const ANALYTICS_APPT_SELECTED = 'amend appt:Appointment selected';
